import { render } from "./EliminarCuenta.vue?vue&type=template&id=b73e4064&scoped=true"
import script from "./EliminarCuenta.vue?vue&type=script&lang=js"
export * from "./EliminarCuenta.vue?vue&type=script&lang=js"

import "./EliminarCuenta.vue?vue&type=style&index=0&id=b73e4064&lang=scss&scoped=true"

import exportComponent from "/home/franco/Desarrollos/NC/gramosDev/Gramos/FrontEnd/trunk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b73e4064"]])

export default __exports__